import { EnumUserStatus, EnumValidStatus } from 'models/record';
/**
    员工管理:STAFF_MANAGE
    评估记录:PRACTICE_RECORD
    组织架构配置:ORG_SETTING
    陪练组管理:PRACTICE_GROUP
    系统管理:SYSTEM_SETTING
    修改密码:CHANGE_PASSWORD
    数据报告:DATA_REPORT
    隐藏记录:HIDE_RECORD
    算法中心:ALGORITHM_CENTER
    仪表盘:DASHBOARD
    反馈管理:FEEDBACK
    重算:PRACTICE_RESCORE
    题目中心:QUESTION_CENTER
 */
const RESOURCE_CODE = {
  STAFF_MANAGE: 'STAFF_MANAGE',
  PRACTICE_RECORD: 'PRACTICE_RECORD',
  ORG_SETTING: 'ORG_SETTING',
  PRACTICE_GROUP: 'PRACTICE_GROUP',
  SYSTEM_SETTING: 'SYSTEM_SETTING',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  DATA_REPORT: 'DATA_REPORT',
  AUTHORITY: 'AUTHORITY',
  PASSWORD: 'PASSWORD',
  HIDE_RECORD: 'HIDE_RECORD',
  ALGORITHM_CENTER: 'ALGORITHM_CENTER',
  DASHBOARD: 'DASHBOARD',
  DASHBOARD_V2: 'DASHBOARD_V2',
  FEEDBACK: 'FEEDBACK',
  PRACTICE_RESCORE: 'PRACTICE_RESCORE',
  QUESTION_CENTER: 'QUESTION_CENTER',
  CASE_MANAGEMENT: 'CASE_MANAGEMENT',
  IDENTITY_MANAGEMENT: 'IDENTITY_MANAGEMENT',
  ADVANCED_SEARCH: 'ADVANCED_SEARCH', // 高级查询
  DOWNLOAD_SCORE_DETAIL: 'DOWNLOAD_SCORE_DETAIL', // 下载评分详情
  TPL_MANAGEMENT: 'TPL_MANAGEMENT',
  FAST_CREATE_UNIT: 'FAST_CREATE_UNIT', // 快速配卷
  TPL_MANAGE: 'TPL_MANAGE', // 模板管理
  PRODUCT_MANAGE: 'PRODUCT_MANAGE', // 项目管理,
  ROUND_PRACTICE_RECORD: 'ROUND_PRACTICE_RECORD', // 练习记录
  EXAM_RECORD: 'EXAM_RECORD', // 考试记录
  TEACHER_PRACTICE_RECORD: 'TEACHER_PRACTICE_RECORD',
  LEARN_CENTER: 'LEARN_CENTER', //学习中心
  ANCHOR_MANAGEMENT: 'ANCHOR_MANAGEMENT', // anchor库管理
  OUTBOUND_REPORT: 'OUTBOUND_REPORT', //外呼报告
  /** 日志管理 */
  SYSTEM_OPERATION_LOG: 'SYSTEM_OPERATION_LOG',
  ORG_STUDENT: 'ORG_STUDENT', // 组织架构学生
  ORG_TEACHER: 'ORG_TEACHER', // 组织架构老师
  COMMUNITY_TOPIC: 'COMMUNITY_TOPIC', // 交流报告
  EXCELLENT_CASE: 'EXCELLENT_CASE', // 优秀案例管理
  EXAM_RESET: 'EXAM_RESET', // 考试重置
  DOWNLOAD_CENTER: 'DOWNLOAD_CENTER', // 下载中心
  CHANGE_EXAM_RECORD_RESULT: 'CHANGE_EXAM_RECORD_RESULT', // 考试详情-更改考试结果按钮
  PRACTICE_RECORD_STATISTICS_DOWNLOAD: 'PRACTICE_RECORD_STATISTICS_DOWNLOAD', // 练习记录累积数据下载 按钮
  PRACTICE_RECORD_DETAILS_DOWNLOAD: 'PRACTICE_RECORD_DETAILS_DOWNLOAD', // 练习记录详情下载 按钮
  PLAINTEXT_GRADING: 'PLAINTEXT_GRADING', // 明文阅卷权限
  MANUAL_MODIFY_EXAM_SCORE: 'MANUAL_MODIFY_EXAM_SCORE', // 考试详情- 人工改分
  /** 项目管理-编辑 */
  PRODUCT_MANAGE_UPDATE: 'PRODUCT_MANAGE_UPDATE',
  /** 项目管理-新建 */
  PRODUCT_MANAGE_CREATE: 'PRODUCT_MANAGE_CREATE',
  /** 项目管理-配置 */
  PRODUCT_MANAGE_CONFIG: 'PRODUCT_MANAGE_CONFIG',
  /** 项目管理-删除 */
  PRODUCT_MANAGE_DELETE: 'PRODUCT_MANAGE_DELETE',
  /** 项目管理-学习小组配置 */
  PRODUCT_MANAGE_LEARN: 'PRODUCT_MANAGE_LEARN',
  /** 项目管理-数据看板 */
  PRODUCT_MANAGE_DATA_BOARD: 'PRODUCT_MANAGE_DATA_BOARD',
  /** 项目管理-安踏-批量题组导入 */
  ROUND_BATCH_IMPORT: 'ROUND_BATCH_IMPORT',
  /** 能力模型报告 */
  ABILITY_MODEL_REPORT: 'ABILITY_MODEL_REPORT',
  /** 考试异常判定与报告同出 */
  EXAM_CHEAT_DETECT_BEFORE_SCORE: 'EXAM_CHEAT_DETECT_BEFORE_SCORE',
  /** 练习异常判定与报告同出 */
  PRACTICE_CHEAT_DETECT_BEFORE_SCORE: 'PRACTICE_CHEAT_DETECT_BEFORE_SCORE',
  /** TTS发音纠正词库 */
  TTS_VOCAB: 'TTS_VOCAB',
  /** AZ定制看板 */
  PRODUCT_MANAGE_CUSTOM_DASHBOARD: 'PRODUCT_MANAGE_CUSTOM_DASHBOARD',
  /** 通知推送管理 */
  PRODUCT_MANAGE_PUSH_RULE: 'PRODUCT_MANAGE_PUSH_RULE',
  /** 员工字典管理 */
  EMPLOYEE_DICT_MANAGE: 'EMPLOYEE_DICT_MANAGE',
  /** 产品知识库 */
  PRODUCT_KNOWLEDGE: 'PRODUCT_KNOWLEDGE',
  /** 人设管理 */
  PEOPLE_PROFILE: 'PEOPLE_PROFILE',
  /** 学习小组-高级配置 */
  LEARN_TEAM_USER_ADVANCE_CONFIG: 'LEARN_TEAM_USER_ADVANCE_CONFIG',
  /** 跨租户复制 */
  COPY_CROSS_TENANT: 'COPY_CROSS_TENANT',
  /** 同步企微三方ID */
  SYNC_WECOM_THIRD_ID: 'SYNC_WECOM_THIRD_ID',
  /** 场景-搜索配置 */
  UNIT_SEARCH_CONFIG: 'UNIT_SEARCH_CONFIG',
  /** 情景-试讲类型 */
  UNIT_TRAIL_LECTURE_TYPE_CONFIG: 'UNIT_TRAIL_LECTURE_TYPE_CONFIG',
  /** 情景-品牌 */
  BRAND_CONFIG: 'BRAND_CONFIG',
  /** 仅复制成员 */
  LEARN_TEAM_COPY_USER: 'LEARN_TEAM_COPY_USER',
  /** 学习小组配置完成时间 */
  LEARN_TEAM_SUGGESTED_COMPLETE_DATE: 'LEARN_TEAM_SUGGESTED_COMPLETE_DATE',
  /** 角色产品选择：陪练、matrix */
  ROLE_PRODUCT_SELECT: 'ROLE_PRODUCT_SELECT',
  /** pc后台的萃取 */
  MATRIX_ENTRANCE: 'MATRIX_ENTRANCE',
  /** AI 题库 */
  AI_QUESTION_LIB: 'AI_QUESTION_LIB',
  /** 考试 特殊及格规则 */
  EXAM_PASS_RULE_CONFIG: 'EXAM_PASS_RULE_CONFIG',
  /** 考试重算 */
  EXAM_RECALCULATE: 'EXAM_RECALCULATE',
  /** 考试pdf下载 */
  EXAM_RECORD_PDF_DOWNLOAD: 'EXAM_RECORD_PDF_DOWNLOAD',
  /** wps推送类型 */
  PUSH_RULE_WPS: 'PUSH_RULE_WPS',
  /** 推送接收方：主管 */
  PUSH_RULE_MANAGER: 'PUSH_RULE_MANAGER'
};

const USER_STATUS_TEXT = {
  [EnumUserStatus.NORMAL]: '在职',
  [EnumUserStatus.RESIGNED]: '离职'
};
const VALID_STATUS_TEXT = {
  [EnumValidStatus.VALID]: '有效',
  [EnumValidStatus.INVALID]: '无效'
};

export { RESOURCE_CODE, USER_STATUS_TEXT, VALID_STATUS_TEXT };
export const QUESTION_CENTER_TYPE = {
  COPY: 'copy'
};

export enum BotType {
  BEEBOT = 'BEEBOT', // 云小蜜
  NOAH = 'NOAH', // 定制
  ADAM = 'ADAM', // 自研
  SSC_QA = 'SSC_QA'
}

export const botTypeOptions = [
  {
    label: '云小蜜',
    value: BotType.BEEBOT
  },
  {
    label: '自研',
    value: BotType.ADAM
  },
  {
    label: '定制',
    value: BotType.NOAH
  }
];

export const TABLE_ASC = 'ascend';
export const API_ASC = 'ASC';
export const API_DESC = 'DESC';

export const MapAudioVideoCheat: any = {
  audioSingle: '音频非一人完成',
  noOne: '画面无人',
  change: '画面换人',
  multi: '画面多人'
};

export const BASE_COS_URL = 'https://ai-coach-prod-1256119856.cos.ap-shanghai.myqcloud.com/public';

export const KEYWORD_EXCLUDE_REG = /[^\u4e00-\u9fa5a-zA-Z0-9(){}[\]|,.]/g;

export const permissionCodeMapPath = {
  // v1 可配置为首页的页面
  [RESOURCE_CODE.DASHBOARD]: `/dashboard`,
  [RESOURCE_CODE.STAFF_MANAGE]: `/stafflist`,
  [RESOURCE_CODE.PRACTICE_RECORD]: `/recordlist/student`,
  [RESOURCE_CODE.FEEDBACK]: `/feedback`,
  // v2 可配置为首页的页面
  [RESOURCE_CODE.DASHBOARD_V2]: `/v2_dashboard`,
  [RESOURCE_CODE.ROUND_PRACTICE_RECORD]: `/practice-record`,
  // 其他
  [RESOURCE_CODE.TEACHER_PRACTICE_RECORD]: `/recordlist/teacher`,
  [RESOURCE_CODE.CASE_MANAGEMENT]: `/case_management`,
  [RESOURCE_CODE.TPL_MANAGE]: `/tpl`,
  [RESOURCE_CODE.PRODUCT_MANAGE]: `/project`,
  [RESOURCE_CODE.EXAM_RECORD]: `/exam-record`,
  [RESOURCE_CODE.COMMUNITY_TOPIC]: `/report/exchangelist`,
  [RESOURCE_CODE.LEARN_CENTER]: `/learn`,
  [RESOURCE_CODE.ORG_SETTING]: `/organization`,
  [RESOURCE_CODE.ORG_SETTING]: `/organization/student`,
  [RESOURCE_CODE.ORG_TEACHER]: `/organization/teacher`,
  [RESOURCE_CODE.AUTHORITY]: `/authority`,
  [RESOURCE_CODE.IDENTITY_MANAGEMENT]: `/identity`,
  [RESOURCE_CODE.PRACTICE_GROUP]: `/identity/:identityId/group`,
  [RESOURCE_CODE.QUESTION_CENTER]: `/questionCenter`,
  [RESOURCE_CODE.ANCHOR_MANAGEMENT]: `/anchor`,
  [RESOURCE_CODE.ALGORITHM_CENTER]: `/algorithmCenter`,
  [RESOURCE_CODE.SYSTEM_SETTING]: `/systemset`,
  [RESOURCE_CODE.DATA_REPORT]: `/report/list`,
  [RESOURCE_CODE.OUTBOUND_REPORT]: `/report/outbound`
};

export const LEFT_ARROW_TEXT = `<`;
export const RIGHT_ARROW_TEXT = '>';

export const OneDecimalRegex = /^(?!-)\d{1,3}(,\d{3})*(\.\d)?$/;

/** 系统语言 */
export enum EnumSysLanguages {
  EN = 'en',
  CN = 'cn',
  HK = 'hk'
}

export const languageSwitchOpts = [
  { value: EnumSysLanguages.CN, label: '中文简体' },
  { value: EnumSysLanguages.HK, label: '中文繁体' },
  { value: EnumSysLanguages.EN, label: '英文' }
];

export const COS_BASE_URL = `https://ai-coach-prod-1256119856.cos.ap-shanghai.myqcloud.com/public/wechat2`;
